import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from "react";
import { useAddress } from "../../polychain/hooks/useAddress";
import { FlowActions } from "../../stores/flowStore";
export function useEndFlowOnAccountChange() {
  const $ = _c(3);
  const address = useAddress();
  const initialAddress = useRef(address);
  let t0;
  let t1;
  if ($[0] !== address) {
    t0 = function endFlowIfAccountChanges() {
      if (initialAddress.current && initialAddress.current !== address) {
        FlowActions.endFlow();
      }
    };
    t1 = [address];
    $[0] = address;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
}